import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { ILoan, ILoansQueryParams, IQueryResult } from 'gen/ApiClient';

export const LoansQueryContext = React.createContext<IQueryContext<IQueryResult<ILoan>, ILoansQueryParams>>(undefined as any);
